import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { objectsIcons } from './defs';
import { Group } from './Circle';
export default class SoulObjects extends React.Component {
    constructor(props) {
        super(props);
        this._objects = [];
        this.update = (newProps) => {
            var _a;
            const { personalization } = newProps.mapSettings;
            const { computedRadius } = newProps;
            for (let i = 0; i < 12; i++) {
                (_a = this._objects[i].current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'none');
            }
            let objectsRadius = 0;
            objectsRadius = newProps.radius * personalization.circle.radius.zodiacsExternal + computedRadius.zodiacsExternal + 40;
            newProps.soulObjects.map((object, index) => {
                const color = 'var(--icon-primary)';
                const p = newProps.point(objectsRadius, 30 * index + 15);
                const _obj = this._objects[index].current;
                _obj.style.display = 'block';
                const obj = _obj.firstChild;
                obj.style.color = color;
                obj.setAttribute('x', p.x.toString());
                obj.setAttribute('y', p.y.toString());
            });
        };
        for (let i = 0; i < 12; i++) {
            this._objects.push(React.createRef());
        }
    }
    shouldComponentUpdate(newProps) {
        this.update(newProps);
        return newProps.mode !== this.props.mode || !!newProps.isEditor;
    }
    componentDidMount() {
        this.update(this.props);
    }
    render() {
        const { props } = this;
        const iconSize = props.radius * props.mapSettings.personalization.circle.objects.iconSize;
        const objects = [];
        const divisions = [];
        const strongs = [];
        for (let id = 0; id < 12; id++) {
            const Icon = objectsIcons[props.soulObjects[id]];
            objects.push(_jsx(Group, { ref: this._objects[id], onClick: () => props.onHelp('objects', id), children: _jsx("svg", { overflow: "visible", children: _jsx(Icon, { x: -iconSize / 2, y: -iconSize / 2, width: iconSize, height: iconSize, fill: "currentColor", stroke: "currentColor", strokeWidth: "0" }) }) }, `${props.mode}_${id}`));
        }
        const outRadius = props.radius * props.mapSettings.personalization.circle.radius.external;
        const endRadius = outRadius + 15;
        for (let i = 0; i < 84; i++) {
            const lon = 360 / 84 * i;
            if (lon % 30 !== 0) {
                const endPos = props.point(endRadius, lon);
                const outPos = props.point(outRadius, lon);
                divisions.push(_jsx(Group, { children: _jsx("line", { stroke: "var(--circle-border)", x1: endPos.x.toString(), y1: endPos.y.toString(), x2: outPos.x.toString(), y2: outPos.y.toString() }) }, `division${i}`));
            }
        }
        const getOrbitRadius = (index) => {
            let { zodiacsInternal, internalSoul } = props.mapSettings.personalization.circle.radius;
            zodiacsInternal = props.radius * props.mapSettings.personalization.circle.radius.zodiacsInternal;
            internalSoul = props.radius * (props.mapSettings.personalization.circle.radius.internalSoul || 0.1);
            const objectsRadius = zodiacsInternal - internalSoul;
            const cellWidth = objectsRadius / 8;
            return cellWidth * (index + 1) + internalSoul + cellWidth / 2;
        };
        for (let i = 0; i <= 6; i++) {
            const { x, y } = this.props.point(getOrbitRadius(i), 0);
            strongs.push(_jsx(Group, { children: _jsx("text", { x: x, y: y - 5, fill: "var(--circle-border)", children: 6 - i }) }, `strong_${i}`));
        }
        return (_jsxs(_Fragment, { children: [objects, divisions, strongs] }));
    }
}
